import { render } from "./LC_productivity.vue?vue&type=template&id=fdcdf772&scoped=true"
import script from "./LC_productivity.vue?vue&type=script&lang=js"
export * from "./LC_productivity.vue?vue&type=script&lang=js"

import "./LC_productivity.vue?vue&type=style&index=0&id=fdcdf772&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdcdf772"]])

export default __exports__